import { render, staticRenderFns } from "./TCircleButton.vue?vue&type=template&id=53d1c87f&scoped=true&"
import script from "./TCircleButton.vue?vue&type=script&lang=ts&"
export * from "./TCircleButton.vue?vue&type=script&lang=ts&"
import style0 from "./TCircleButton.vue?vue&type=style&index=0&id=53d1c87f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d1c87f",
  null
  
)

export default component.exports